<div class="scenario-description-container">
    <div class="scenario-description-label">Nombre Escenario</div>
    <div class="scenario-description">{{label}}</div>
</div>
